<!-- <div class="dialog-header">
    <div class="title-dialog"></div>
    <button type="button" class="btn-close-dialog" (click)="cancel()">
        <img src="assets/icons/closeOutlined.svg" />
    </button>
</div>

<div class="dialog-content">
    {{ data.message }}
</div>

<div class="dialog-actions">
    <button type="button" class="btn btn-cancel" (click)="cancel()">{{ data.textCancel }}</button>
    <button type="button" class="btn btn-confirm" (click)="confirm()">{{ data.textConfirm }}</button>
</div> -->

<div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title mr-4">{{ data.title }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="cancel();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
</div>
<div class="modal-body">
    <p class="modal-text"> {{ data.message }} </p>
</div>
<div class="modal-footer">
    <div class="align-items-end d-flex">
        <button (click)="cancel()" class="btn-bd-empty separate-buttons">{{ data.textCancel }}</button>
        <button (click)="confirm()" class="btn-bd">{{ data.textConfirm}}</button>
    </div>
</div>